import Component from 'cartware-component';
import $ from 'jquery';
import BEM from 'jquery-bem';

/* eslint-disable no-undef */
class CookieOverlay {
    COOKIE_CONSENT_IDENTIFIER_YOUTUBE = 'youtube';

    COOKIE_CONSENT_IDENTIFIER_RECAPTCHA = 'google_recaptcha';

    COOKIE_OVERLAY_CLASS_YOUTUBE = 'b_cookie-overlay-youtube';

    CATEGORY_VIDEO_HEADER_VIDEO_CLASS = BEM.buildElementClassname('b_category-video-header', 'video');

    init() {
        this.initializeElements();
        this.handleInitialCookieConsent();
        this.bindEvents();
    }

    initializeElements() {
        this.categoryVideoItems = $('.b_product-item--video');
        this.cmsVideoItems = BEM.block('category-video-header');
        this.instructionalVideoItems = BEM.block('instructional-video');
        this.newsletterSubscribeFooter = BEM.block('newsletter-subscribe-footer');
        this.customerCreateBlock = BEM.block('customer-create');
        this.contactForm = BEM.block('contact-form');
        this.formOverlays = BEM.block('cookie-overlay-form');
        this.youtubeOverlay = this.getYoutubeOverlayHtml();
    }

    handleInitialCookieConsent() {
        // eslint-disable-next-line no-undef
        const agreedCookies = CartwareCookieConsent.getAgreedCookieIdentifiers() || [];

        if (!agreedCookies.length) {
            // No cookies set, add all relevant overlays
            this.addRecaptchaOverlay();
            this.addYoutubeOverlay();
        } else {
            // Handle cookies if set
            if (!agreedCookies.includes(this.COOKIE_CONSENT_IDENTIFIER_YOUTUBE)) {
                this.addYoutubeOverlay();
            } else {
                this.removeYoutubeOverlay();
            }

            if (!agreedCookies.includes(this.COOKIE_CONSENT_IDENTIFIER_RECAPTCHA)) {
                this.addRecaptchaOverlay();
            } else {
                this.removeRecaptchaOverlay();
            }
        }
    }

    bindEvents() {
        const handleConsentAdd = (event, eventData) => {
            const cookieIdentifier = eventData?.cookieIdentifier;
            if (!cookieIdentifier) return;

            if (cookieIdentifier === this.COOKIE_CONSENT_IDENTIFIER_YOUTUBE) {
                this.removeYoutubeOverlay();
            } else if (cookieIdentifier === this.COOKIE_CONSENT_IDENTIFIER_RECAPTCHA) {
                this.removeRecaptchaOverlay();
            }
        };

        const handleConsentWithdrawal = (event, eventData) => {
            const cookieIdentifier = eventData?.cookieIdentifier;
            if (!cookieIdentifier) return;

            if (cookieIdentifier === this.COOKIE_CONSENT_IDENTIFIER_YOUTUBE) {
                this.addYoutubeOverlay();
            } else if (cookieIdentifier === this.COOKIE_CONSENT_IDENTIFIER_RECAPTCHA) {
                this.addRecaptchaOverlay();
            }
        };

        // eslint-disable-next-line no-undef
        CartwareCookieConsent.eventEmitter.subscribe('addedConsent', handleConsentAdd);
        // eslint-disable-next-line no-undef
        CartwareCookieConsent.eventEmitter.subscribe('withdrawnConsent', handleConsentWithdrawal);
    }

    toggleFormOverlay(show) {
        this.formOverlays.each((_, e) => {
            $(e).toggle(show);
        });

        const toggleCTA = (ctaElement, disable) => {
            // eslint-disable-next-line no-unused-expressions
            disable ? ctaElement.attr('disabled', true) : ctaElement.removeAttr('disabled');
        };

        toggleCTA(this.newsletterSubscribeFooter.getElements('subscribe'), show);
        toggleCTA(this.customerCreateBlock.getElements('submit'), show);
        toggleCTA(this.contactForm.getElements('submit'), show);
    }

    addRecaptchaOverlay() {
        this.toggleFormOverlay(true);
    }

    removeRecaptchaOverlay() {
        this.toggleFormOverlay(false);
    }

    toggleOverlayDisplay(display, containerSelector, innerWrapperSelector, frameSelector = null) {
        containerSelector.each((_, e) => {
            const container = $(e);
            let iframe;

            if (container.find('lite-youtube').length > 0) {
                iframe = container.find('lite-youtube');
            } else if (container.find('iframe').length > 0) {
                iframe = container.find('iframe');
            } else {
                return;
            }

            const cookieOverlay = container.find(`.${this.COOKIE_OVERLAY_CLASS_YOUTUBE}`);
            const innerWrapper = container.bemGetElements(innerWrapperSelector);
            const frameWrapper = frameSelector ? container.bemGetElements(frameSelector) : innerWrapper.children('div').first();

            if (display && cookieOverlay.length === 0) {
                innerWrapper.append(this.youtubeOverlay);
            } else {
                cookieOverlay.toggle(display);
            }

            if (frameWrapper.length > 0) {
                frameWrapper.toggle(!display);
            }

            if (iframe.length > 0) {
                if (!display) {
                    const videoId = iframe.attr('videoid');
                    const frameSrc = iframe.data('frame-src') || null;

                    innerWrapper.css('display', 'block');

                    if (frameSrc) {
                        iframe.attr('src', frameSrc);
                    }

                    if (videoId) {
                        const backgroundImage = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
                        iframe.css('background-image', `url('${backgroundImage}'`);
                    }
                } else {
                    iframe.removeAttr('src');
                    iframe.css('background-image', 'none');
                }
            }
        });
    }

    addYoutubeOverlay() {
        this.toggleOverlayDisplay(true, this.categoryVideoItems, 'wrapper', 'frame-wrapper');
        this.toggleOverlayDisplay(true, this.cmsVideoItems, 'video-wrapper');
        this.toggleOverlayDisplay(true, this.instructionalVideoItems, 'video-wrapper');
    }

    removeYoutubeOverlay() {
        this.toggleOverlayDisplay(false, this.categoryVideoItems, 'frame-wrapper');
        this.toggleOverlayDisplay(false, this.cmsVideoItems, 'video-wrapper');
        this.toggleOverlayDisplay(false, this.instructionalVideoItems, 'video-wrapper');
    }

    // eslint-disable-next-line class-methods-use-this
    getYoutubeOverlayHtml() {
        return `<div class="b_cookie-overlay-youtube">
                    <div class="b_cookie-overlay-youtube__container">
                        <div class="b_cookie-overlay-youtube__wrapper">
                            <div class="b_cookie-overlay-youtube__content">
                                <span class="b_cookie-overlay-youtube__icon"></span>
                                <p class="b_cookie-overlay-youtube__text">${Translator.translate('Please accept Functional Cookies to display the Youtube video.')}</p>
                            </div>
                            <div class="b_cookie-overlay-youtube__cta btn btn-secondary" onClick="CartwareCookieConsent.prompt()">${Translator.translate('Cookie-Settings')}</div>
                        </div>
                    </div>
                </div>
            `;
    }
}

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["domready"] }] */
/* eslint-disable no-undef */
export default class extends Component {
    domready() {
        const overlay = new CookieOverlay();
        overlay.init();
    }
}
